import React from 'react';

import { Avatar, Flex, Group, Paper, Stack, Text, useMantineTheme } from '@mantine/core';
import {
  IconCalendarUser,
  IconChevronRight,
  IconCircleFilled,
  IconClock,
  IconMapPin,
  IconUser,
} from '@tabler/icons-react';
import KiloButton from 'components/KiloButton';

interface IEventCardAppointment {
  title: string;
  returnStylesForStartsInStatuses: StartsInStatusesColors;
  startsIn: string;
  isEnded: boolean;
  eventDurationDateAndTime: string;
  coachNames: string;
  duration: number;
  location: string;
  onClick: () => void;
  profilePicture: string;
  eventName: string;
  isDesktop?: boolean;
}

type StartsInStatusesColors = {
  text: string;
  background: string;
  border: string;
  borderWidth: string;
};

const EventCardAppointment = ({
  title,
  returnStylesForStartsInStatuses,
  startsIn,
  isEnded,
  eventDurationDateAndTime,
  coachNames,
  duration,
  location,
  onClick,
  profilePicture,
  eventName,
  isDesktop,
}: IEventCardAppointment): JSX.Element => {
  const theme = useMantineTheme();
  return (
    <Paper onClick={isDesktop ? onClick : undefined}>
      <Group position='apart' mb={7}>
        <Group spacing={12} style={{ flex: 1, overflow: 'hidden', maxWidth: '70vw' }} noWrap>
          <Avatar size={isDesktop ? 54 : 28} radius={'100%'} src={profilePicture} />
          <Text weight={700} size={isDesktop ? 21 : 18} truncate>
            {title}
          </Text>
        </Group>
        <Group
          bg={returnStylesForStartsInStatuses?.background}
          py={4}
          px={18}
          style={{ borderRadius: '12px', color: returnStylesForStartsInStatuses?.text }}
          spacing={16.5}
        >
          <Text weight={400} size={isDesktop ? theme.spacing.md : theme.spacing.sm}>
            {startsIn}
          </Text>
          {isEnded && <IconCircleFilled size={8} />}
        </Group>
      </Group>
      <Text weight={700} size={isDesktop ? 21 : 16}>
        {eventName}
      </Text>
      <Flex p={0} m={0} mt={14}>
        <Stack w={'100%'} spacing={14}>
          <Group spacing={8} noWrap>
            <IconCalendarUser size={isDesktop ? 21 : 16} />
            <Text weight={400} size={isDesktop ? 21 : 16}>
              {eventDurationDateAndTime}
            </Text>
          </Group>
          <Group spacing={8}>
            <IconUser size={isDesktop ? 21 : 16} />
            <Text weight={400} size={isDesktop ? 21 : 16}>
              {coachNames} (Coach)
            </Text>
          </Group>
        </Stack>

        <Stack w={isDesktop ? '80%' : '45%'} spacing={14}>
          <Group spacing={8}>
            <IconClock size={isDesktop ? 21 : 16} />
            <Text weight={400} size={isDesktop ? 21 : 16}>
              {duration} Mins
            </Text>
          </Group>

          <Group spacing={8}>
            <IconMapPin size={isDesktop ? 21 : 16} />
            <Text weight={400} size={isDesktop ? 21 : 16}>
              {location}
            </Text>
          </Group>
        </Stack>

        <Group align='flex-end'>
          {isDesktop ? (
            <KiloButton w={'fit-content'} onClick={onClick}>
              <Text fw={600} size={18} transform='capitalize'>
                see appointment
              </Text>
            </KiloButton>
          ) : (
            <Group
              bg={'#E1F3FE'}
              w={isDesktop ? 48 : 35}
              h={isDesktop ? 48 : 35}
              style={{
                borderRadius: '50%',
                justifyContent: 'center',
                cursor: 'pointer',
                alignSelf: 'flex-start',
              }}
              onClick={onClick}
            >
              <IconChevronRight color='#15B8FF' type='default' />
            </Group>
          )}
        </Group>
      </Flex>
    </Paper>
  );
};

export default EventCardAppointment;
